"use client";
import { getTranslation } from "@/i18n/get-translation";
import Link from "next/link";

interface IHowLucyHelpYouRequestDemoBlock {
  locale: string;
}
export default function HowLucyHelpYouRequestDemoBlock({
  locale,
}: IHowLucyHelpYouRequestDemoBlock) {
  const t = getTranslation(locale, "howLucyhelpYou.hero");

  return (
    <section className="relative text-center lg:mb-40 md:mb-32 sm:mb-24 mb-12 2xl:px-32 px-20 pt-28 pb-28 max-md:px-7 max-md:pb-12 max-md:pt-16 bg-appointments-gradient">
      <div className="flex justify-center items-center flex-col max-md:flex-wrap">
        <h3 className="xl:text-[3rem] lg:text-[2.5rem] md:text-[2.2rem] text-[1.88rem] leading-none font-medium mx-auto text-primary-800 mb-0">
          {t("howLucyhelpYouTitle")}
        </h3>
        <div className="flex mt-6">
          <Link
            href={`/${locale}/request-demo`}
            className="whitespace-nowrap arrowBtn text-white bg-(image:--primary-gradient) rounded-full pl-5 pr-2 py-2 leading-4 flex items-center"
          >
            {t("requestDemo")}
            <div className="relative ml-2">
              <div className="bg-primary-400 text-white rounded-full w-10 h-10 opacity-[0.24]"></div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 10 18"
                className="w-[0.625rem] text-white font-bold absolute left-2/4 top-2/4 transform-[translate(-50%,-50%)]"
              >
                <path stroke="currentColor" d="M1 16.5 8 9 1 1.5"></path>
              </svg>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}
